// @flow

import React from 'react';
import { connect } from 'react-redux';
import { setContactFormShowStatus } from '../../redux/actionsCreators';
import type { DefaultStateType } from '../../redux/reducers';
import classnames from 'classnames';

type Props = {
  setContactFormShowStatus: (status: boolean) => void,
  additionalClass: string,
};

const ContactButton = (props: Props) => {
  const showContactForm = () => {
    props.setContactFormShowStatus(true);

    if (document && document.body) {
      document.body.classList.add('showContactForm');
    }
  };

  const { additionalClass } = props;

  return (
    <div onClick={showContactForm} className={classnames('btn', additionalClass)} data-animation="fadeInRight">
      <span>Contact Us</span>
    </div>
  );
};

const mapStateToProps = (state: DefaultStateType): { showContactForm: boolean } => ({
  showContactForm: state.showContactForm,
});

const mapDispatchToProps = (dispatch): Object => ({
  setContactFormShowStatus(status) {
    dispatch(setContactFormShowStatus(status));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactButton);



// WEBPACK FOOTER //
// ./src/components/Contact/Button.js